import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Tooltip} from 'antd';
import {StyledUnlinkBudgetButton, StyledUnlinkBudgetButtonModalIconWrapper} from './StyledUnlinkBudgetButton';
import ModalWithIcon from '../../../modals/ModalWithIcon';
import {LinkBrokenIcon} from '../../../../icons';
import {DEFAULT_MODAL_PROPS} from '../../../../constants';

const UnlinkBudgetButton = ({
  onOk,
}) => {
  const [t] = useTranslation(['main', 'invoices']);
  const [modalProps, setModalProps] = useState(DEFAULT_MODAL_PROPS);

  const trans = (key) => t(`invoices:modal.unlink.${key}`);

  const handleOnClick = (e) => {
    e.stopPropagation();
    setModalProps({...modalProps, open: true});
  }

  const handleCloseModal = () => setModalProps({...modalProps, open: false});

  const handleOk = () => {
    onOk?.();
    handleCloseModal();
  }

  return (
    <>
      <Tooltip title={t('unlink')}>
        <StyledUnlinkBudgetButton colorMode='stroke' size={16} onClick={handleOnClick}>
          <LinkBrokenIcon />
        </StyledUnlinkBudgetButton>
      </Tooltip>

      <ModalWithIcon
        {...modalProps}
        contentDescription={trans('content.description')}
        contentTitle={trans('content.title')}
        icon={(
          <StyledUnlinkBudgetButtonModalIconWrapper>
            <LinkBrokenIcon />
          </StyledUnlinkBudgetButtonModalIconWrapper>
        )}
        handleCancel={handleCloseModal}
        handleOk={handleOk}
        title={trans('title')}
        okText={trans('title')}
      />

    </>
  );
}

UnlinkBudgetButton.propTypes = {
  onOk: PropTypes.func,
}

export default UnlinkBudgetButton;
